import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@nextiva/next-ui-components';

import GreetingActions from '../GreetingActions';

const GreetingRow = ({
  assignedAnnouncement,
  defaultAnnouncement,
  greeting,
  onDeleteUserGreeting,
  onSetUserGreeting,
}) => {
  const isAssignedGreeting = greeting.greetingName === assignedAnnouncement;
  const isDefaultGreeting = greeting.greetingName === defaultAnnouncement;

  return (
    <div className="m-voicemail-table-row">
      <Grid container alignItems="center" wrap="nowrap" spacing={1}>
        <Grid item xs={9}>
          {greeting.greetingName}
          {isAssignedGreeting && (
            <strong style={{ marginLeft: 16 }} data-test-id="currentVmText">
              This is your current voicemail greeting.
            </strong>
          )}
        </Grid>
        <Grid item xs={3} data-test-id="greetingVmActions">
          <div className="actionBase--selector" style={{ paddingTop: 0 }}>
            {(!isAssignedGreeting || !isDefaultGreeting) && (
              <GreetingActions
                isAssignedGreeting={isAssignedGreeting}
                isDefaultGreeting={isDefaultGreeting}
                greeting={greeting}
                onDeleteUserGreeting={onDeleteUserGreeting}
                onSetUserGreeting={onSetUserGreeting}
              />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

GreetingRow.propTypes = {
  assignedAnnouncement: PropTypes.string.isRequired,
  defaultAnnouncement: PropTypes.string.isRequired,
  greeting: PropTypes.shape({
    greetingName: PropTypes.string.isRequired,
    greetingType: PropTypes.string.isRequired,
  }).isRequired,
  onDeleteUserGreeting: PropTypes.func.isRequired,
  onSetUserGreeting: PropTypes.func.isRequired,
};
GreetingRow.displayName = 'GreetingRow';

export default React.memo(GreetingRow);
